import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { MaterialChangeBuilder } from '../../models/builders/material-change.builder';
import { getErrorPrefixOptions } from '../base/headers';
import { ManufacturingOrder } from '../../models/manufacturing-order';
import { MaterialBuilder } from '../../models/builders/material.builder';

@Injectable()
export class MaterialApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }materials`;
  }

  validateExcel(manufacturingOrder: string, file: File) {
    const postBody = new FormData();
    postBody.append('file', file);
    const options = getErrorPrefixOptions('dashboard.material.error');

    return this.httpClient.post(`${ this.apiUrl }/validate_excel/${ manufacturingOrder }`, postBody, options)
      .pipe(
        map(MaterialChangeBuilder.fromJson)
      );
  }

  uploadExcel(manufacturingOrder: string, file: File) {
    const postBody = new FormData();
    postBody.append('file', file);
    const options = getErrorPrefixOptions('dashboard.material.error');

    return this.httpClient.post(`${ this.apiUrl }/upload_excel/${ manufacturingOrder }`, postBody, options);
  }

  getMaterialsByManufacturingOrder(order: ManufacturingOrder) {
    const params = new HttpParams().append('manufacturingOrder', order.hash);

    return this.httpClient.get(`${ this.apiUrl }`, { params })
      .pipe(
        map(MaterialBuilder.fromList)
      );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/material-api.service.ts